import React from 'react';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui';

/** @type {Record<string, import('react').CSSProperties>} */
const styles = {
    headRow: { height: '35px', display: 'block', borderBottom: '1px solid #000' },
    headRowCol: {
        height: '35px', width: '234px', padding: 0, fontSize: '12px', color: 'rgba(0, 0, 0, 0.60)',
    },
    body: {
        maxHeight: '400px', overflowX: 'hidden', overflowY: 'auto',
    },
    bodyRow: { display: 'flex', height: '46px', borderBottom: '1px solid #000' },
    bodyRowCol: {
        height: '46px', width: '234px', padding: '11px 0', color: 'rgba(0, 0, 0, 0.60)', 
    },
};

/**
 * 
 * @param {Props} props 
 */
export default function UpdateRealCargoGazTable(props) {
    return (
        <Table selectable={false} bodyStyle={styles.body}>
            <TableHeader 
                displaySelectAll={false} 
                adjustForCheckbox={false}
            >
                <TableRow style={styles.headRow}>
                    <TableHeaderColumn style={styles.headRowCol}>
                        CargoName
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.headRowCol}>
                        Cargo Real Name
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.headRowCol}>
                        Cargo type
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.headRowCol}>
                        Details
                    </TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody 
                displayRowCheckbox={false}
            >
                {
                    props.gazetters.map(gazetter => (
                        <TableRow 
                            key={gazetter._id}
                            style={styles.bodyRow}
                        >
                            <TableRowColumn style={styles.bodyRowCol}>
                                {gazetter.value}
                            </TableRowColumn>
                            <TableRowColumn style={styles.bodyRowCol}>
                                {gazetter.realCargoName}
                            </TableRowColumn>
                            <TableRowColumn style={styles.bodyRowCol}>
                                {gazetter.CargoCategoryName}
                            </TableRowColumn>
                            <TableRowColumn style={styles.bodyRowCol}>
                                {gazetter.details}
                            </TableRowColumn>
                        </TableRow>
                    ))
                }
            </TableBody>
        </Table>
    );
}

/**
 * @typedef Props
 * @property {import('./UpdateRealCargoDialog').Gazetter[]} gazetters
 */



// WEBPACK FOOTER //
// ./app/components/Cargoes/Assigners/UpdateRealCargoGazTable.jsx